module.exports = __webpack_public_path__ + "img/logout.bce1f0bc.svg";